import React, { forwardRef, ForwardRefRenderFunction, useImperativeHandle, useState } from "react";
import { User } from "authing-js-sdk";
import { Form, message } from "antd";
import { Rule } from "antd/lib/form";

import { FormInstance } from "../../../../hooks/createForm";
import { VerifyCodeInput } from "../../../VerifyCodeInput";
import Axios from "axios";
import styles from "./style.module.less";
import { useTranslation } from "react-i18next";

const CODE_LEN = 6;

export interface MFALoginFormProps extends React.HTMLAttributes<HTMLDivElement> {
  onSubmit?: () => void;
  onSuccess?: (user: User) => void;
  onFail?: (error: any) => void;
  MFAToken: string;
}

export const InternalMFALoginForm: ForwardRefRenderFunction<FormInstance, MFALoginFormProps> = (
  { onSubmit, onSuccess, onFail, MFAToken },
  ref
) => {
  const [rawForm] = Form.useForm();
  const { t } = useTranslation();

  const [MFACode, setMFACode] = useState(new Array(CODE_LEN).fill(""));

  const onFinish = async (values: any) => {
    try {
      const res: any = await Axios.post(
        "/api/v2/mfa/totp/verify",
        {
          totp: MFACode.join(""),
        },
        {
          headers: {
            authorization: MFAToken,
          },
        }
      );
      if (res.code !== 200) {
        message.error(res.message);
        onFail?.(res);
        return;
      }
      onSuccess && onSuccess(res.data);
    } catch (e) {
      onFail?.(e);
      message.error(e.message);
    }
  };

  const rules: Rule[] = [
    {
      validateTrigger: [],
      validator(r, v, cb) {
        if (MFACode.some((item) => !item)) {
          cb(t("login.inputFullMfaCode"));
          return;
        }
        cb();
      },
    },
  ];

  const submit = async () => {
    try {
      onSubmit?.();
      await rawForm.validateFields();
      rawForm.submit();
    } catch (error) {
      onFail && onFail(error);
    }
  };

  useImperativeHandle(ref, () => ({
    submit,
  }));

  return (
    <>
      <h3 className={styles.title}>{t("login.accPwdLoginVerify")}</h3>
      <p className={styles.tips}>{t("login.inputSixCode")}</p>
      <Form form={rawForm} onSubmitCapture={onSubmit} onFinish={onFinish}>
        <Form.Item name="mfaCode" rules={rules}>
          <VerifyCodeInput
            size="40px"
            gutter="18px"
            verifyCode={MFACode}
            setVerifyCode={setMFACode}
            onEenter={submit}
          />
        </Form.Item>
      </Form>
    </>
  );
};

export const MFALoginForm = forwardRef<FormInstance, MFALoginFormProps>(InternalMFALoginForm);
